import { useEffect, useRef, useState } from "react";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import { toast } from "react-toastify";
import CommonDialog from "../../common/commonDialog";
import { uploadVendorDocument } from "../../api/ap_services";

const ALLOWED_EXTENSIONS = [".xlsx", ".csv"];

const isAllowedFile = (file) => {
  if (!file?.name) return false;
  const lowerName = file.name.toLowerCase();
  return ALLOWED_EXTENSIONS.some((ext) => lowerName.endsWith(ext));
};

const LedgerApVendorDocumentUploadModal = (props) => {
  const { open, onCancel, vendorCode, setParentLoading } = props;
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [remarks, setRemarks] = useState("");

  useEffect(() => {
    if (!open) {
      setSelectedFile(null);
      setRemarks("");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  }, [open]);

  const onFileChosen = (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      setSelectedFile(null);
      return;
    }
    if (!isAllowedFile(file)) {
      toast.warning("Only .xlsx and .csv files are allowed.");
      event.target.value = "";
      setSelectedFile(null);
      return;
    }
    setSelectedFile(file);
  };

  const handleSubmit = () => {
    if (!vendorCode) {
      toast.warning("Vendor code is not available.");
      return;
    }
    if (!selectedFile) {
      toast.warning("Please choose a file first.");
      return;
    }
    const createdBy =
      JSON.parse(sessionStorage.getItem("userData") || "{}")?.username || vendorCode;

    setParentLoading?.(true);
    uploadVendorDocument(vendorCode, remarks, selectedFile, createdBy)
      .then((res) => {
        setParentLoading?.(false);
        const body = res.response;
        if (body?.responseCode === true) {
          toast.success(body.message || "Document uploaded successfully");
          onCancel?.();
        } else {
          toast.error(body?.message || "Upload failed");
        }
      })
      .catch(() => {
        setParentLoading?.(false);
        toast.error("Upload failed");
      });
  };

  return (
    <CommonDialog
      onCancel={onCancel}
      onSave={handleSubmit}
      open={open}
      primaryButtonLabel="Submit"
      secondaryButtonLabel="Close"
      title="Vendor Document Upload"
      maxWidth="sm"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
            style={{ display: "none" }}
            onChange={onFileChosen}
          />
          <Button
            variant="contained"
            color="primary"
            startIcon={<UploadFile />}
            onClick={() => fileInputRef.current?.click()}
          >
            Choose file
          </Button>
          {selectedFile ? (
            <Typography variant="body2" sx={{ mt: 1 }} display="block">
              Selected: {selectedFile.name}
            </Typography>
          ) : (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }} display="block">
              Accepted formats: .xlsx, .csv
            </Typography>
          )}
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Remarks"
            size="small"
            multiline
            minRows={3}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            inputProps={{ maxLength: 500 }}
          />
        </Grid>
      </Grid>
    </CommonDialog>
  );
};

export default LedgerApVendorDocumentUploadModal;
